import React from 'react';
import useElementSaveMediaResize, {
    ElementSaveMediaResize,
    RequiredMediaResizeProps,
} from './useElementSaveMediaResize';
import { ELEMENT_DEFAULT_WIDTH } from '../../../../common/elements/elementConstants';

export default (config: {
        getDefaultWidth?: (props: RequiredMediaResizeProps) => number;
        getDefaultMaxWidth?: (props: RequiredMediaResizeProps) => number;
    }) =>
    (
        DecoratedComponent: React.ComponentType<RequiredMediaResizeProps>,
    ): React.FC<RequiredMediaResizeProps & ElementSaveMediaResize> => {
        return (props: RequiredMediaResizeProps) => {
            const { getDefaultWidth = () => ELEMENT_DEFAULT_WIDTH, getDefaultMaxWidth } = config || {};
            const mediaResizeProps = useElementSaveMediaResize(props, getDefaultWidth, getDefaultMaxWidth);
            return <DecoratedComponent {...props} {...mediaResizeProps} />;
        };
    };
